import { render, staticRenderFns } from "./ItemStockModal.vue?vue&type=template&id=600b6c30&scoped=true"
import script from "./ItemStockModal.vue?vue&type=script&lang=js"
export * from "./ItemStockModal.vue?vue&type=script&lang=js"
import style0 from "./ItemStockModal.vue?vue&type=style&index=0&id=600b6c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b6c30",
  null
  
)

export default component.exports